import LayoutScreen from '../../components/layout';
import iconArrowLeft from '../../assets/icon/icon_arrow_left.svg';
import imgProduk from '../../assets/image/img-produk-2.png';
import iconArrowRight from '../../assets/icon/icon_arrow_right.svg';
import { useNavigate } from 'react-router-dom';
import CardProduk from './cardProduk';
import { useEffect, useState } from 'react';
import axios from 'axios';
import CONFIG from '../../config/apiConfig';

const PageListProduk = (props) => {
  const navigate = useNavigate();
  const [listProduk, setListProduk] = useState([]);

  const handleBack = () => {
    navigate('/'); // Programmatically navigate to /new-route
  };

  useEffect(() => {
      fetchListProduk();
  }, []);

  const fetchListProduk = async () => {
    try {
      const response = await axios.get(CONFIG.API_URL + '/products/lists');
      if(response?.data?.data !== null){
        setListProduk(response?.data?.data);
      }

    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  return (
    <LayoutScreen transparent>
      <div className="relative flex flex-col flex-grow h-full mt-5">
        <div className="h-full flex flex-col flex-grow justify-start items-center">
          <div className=" w-full flex space-x-4 justify-between items-start">
            <div
              onClick={() => handleBack()}
              className="w-full cursor-pointer flex space-x-2 md:space-x-4 justify-start items-center">
              <img
                src={iconArrowLeft}
                alt="icon arrow left"
                className="w-5 h-5 md:w-8 md:h-8 object-contain"
              />
              <div className=" w-full md:text-2xl font-semibold text-textBlack">
                Produk
              </div>
            </div>
          </div>

          <div className="flex w-full py-5">
            <div className="grid grid-cols-2 gap-3 md:grid-cols-2 xl:grid-cols-4 md:gap-5">
              {
                listProduk.map((item, key) => {
                  return  <CardProduk key={key} produk={item} />
                })
              }

            </div>
          </div>
        </div>
      </div>
    </LayoutScreen>
  );
};

export default PageListProduk;
